import React from 'react'
import { generateDateString } from 'utils/time'
import { Button } from 'components/UIElements'
import { navigateTo } from 'navigation'
import { FALLBACK_STRINGS } from 'utils/constants'

const Consent = ({
  consent,
  strings,
  consent_status,
  downloadConsentPDF,
  downloadSignConsentPDF,
  studyID,
  onFetchConsentDetails
}) => {
  const {
    consent_id,
    consent_title,
    completed,
    consent_type,
    last_deployed_version
  } = consent

  const onPendingConsentClick = (consent_id, last_deployed_version) => {
    // Wait for consent details to load before navigating so /consent has the form
    // and does not redirect back to profile (hasMultipleConsentsNoForm).
    const fetchPromise = onFetchConsentDetails(consent_id, last_deployed_version)
    if (fetchPromise && typeof fetchPromise.then === 'function') {
      fetchPromise.then(() => navigateTo('/consent'))
    } else {
      navigateTo('/consent')
    }
  }

  return (
    <div className='ptp-consent' key={`consent-${consent_id}`}>
      <div className='flexed'>
        <div>
          {consent_type ? (
            <div className='bold'>{strings[consent_type + '_form']}</div>
          ) : null}
        </div>
        <div>
          <div>
            {completed
              ? `${strings.signed_on || FALLBACK_STRINGS.signed_on} ${generateDateString(completed, strings)}`
              : strings.not_signed || FALLBACK_STRINGS.not_signed}
          </div>
        </div>
        <div>
          <Button
            link
            onClick={() =>
              consent_status == 'pending'
                ? onPendingConsentClick(consent_id, last_deployed_version)
                : downloadSignConsentPDF(
                  studyID,
                  consent_title,
                  consent_id
                )
            }
            content={`${consent_title}.pdf`}
          />
        </div>
      </div>
    </div>
  )
}

export default Consent
